import React from "react";
import { Flex, Box } from "@chakra-ui/react";
import Sidebar from "../Sidebar";
import { mainNav } from "../Navbar";
import { Outlet } from "react-router-dom";

export const ShredLayout = () => {
    return (
        <>
            <Flex height={"100vh"}>
                <Sidebar navRoutes={mainNav} isMainNav={true} />
                <Box
                    display={"flex"}
                    flexDirection={"column"}
                    width={"100%"}
                    height={"100%"}
                    overflow={"hidden"}
                    padding={4}
                    paddingBottom={2}
                >
                    <Outlet />
                </Box>
            </Flex>
        </>
    );
};
